import React from "react";
import parse from "html-react-parser";
import "./Home.css";

function UpcomingInfo(props) {
  return (
    <div className="upcoming-info">
      <div className="jumbotron">
        <h1 className="display-4">{parse(props.info.title)}</h1>
        <hr className="my-4"></hr>
        <p>{parse(props.info.content)}</p>
        <p className="info-author">autor: {props.info.author}</p>
      </div>
    </div>
  );
}

export default UpcomingInfo;
